import { IconButton, Stack, SvgIcon, Tooltip, Typography } from "@mui/material";
import { CSSProperties, ChangeEvent, FC, RefObject, useCallback, useMemo } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { getStyles } from "./styles";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../../locales/tokens";

interface IProps {
    isDisabled?: boolean;
    imageSrc: string;
    isValid: boolean;
    handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleClearImageClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ImagePicker: FC<IProps> = ({ imageSrc, handleFileChange, isValid, handleClearImageClick, isDisabled }) => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);

    return (
        <>
            <Stack pt={1} position="relative" >
                <Typography color={isValid? "primary" : "error"} variant="h6" pb={1}>Додати зображення</Typography>
                <label htmlFor="fileInput" className="image">
                    <Tooltip title={t(tokens.notification.addImage)} placement="right">
                        <img
                            src={imageSrc || "/images/user/uploadImage.png"}
                            alt="uploadImage"
                            width={100}
                            height={100}
                            style={styles.cover as CSSProperties}
                        />
                    </Tooltip>
                    {imageSrc ?
                        <IconButton sx={styles.clearImage} onClick={handleClearImageClick}>
                            <Tooltip title={t(tokens.notification.removeImage)} >
                                <SvgIcon fontSize="small" sx={{ fontSize: '14px' }}><ClearIcon/></SvgIcon>
                            </Tooltip>
                        </IconButton>
                        : null
                    }
                </label>
                <input
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    style={{ display: 'none', cursor: 'pointer' }}
                    onChange={handleFileChange}
                    disabled={isDisabled}
                />
            </Stack>
        </>
    )
};